<template>
    <section class="wrap-config">
      <header>
        <ul>
          <span v-for="(item, index) in tabList" :key="index">
            <li
              @click="tabClick(item.name)"
              :class="item.name == tabName ? 'act' : ''"
            
            >
              <span v-text="item.title"></span>
            </li>
          </span>
        </ul>
        <div>
  
        </div>
      </header>
      <main >
        <component
          :is="tabName"
        ></component>
      </main>
    
    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        // tab切换菜单项
        tabList: [
          {
            title: "使用列表",
            name: "useList",
          },
          {
            title: "分配管理",
            name: "allocationManage",
          },

          
        ],
        // 当前tab页名
        tabName: "allocationManage",

        //点击跳转标签名
        nextTab: "",
      };
    },
    components: {
      allocationManage: () => import("./permitConfig/M_allocation.vue"),
      useList: () => import("./permitConfig/M_useList.vue"),
    },
    methods: {
      tabClick(name){
        this.tabName = name
      }
    },
    beforeMount(){
      if (this.$cookies.get('licenseState')) {
         this.tabName = 'useList'
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .wrap-config {
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    margin: -8px;
    header {
      position: absolute;
      z-index: 9;
      box-sizing: border-box;
      width: 100%;
      padding: 0 20px;
      background-color: #fff;
      border-top: 1px #e4e8ec solid;
      padding-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        display: flex;
        justify-content: space-between;
        // align-items: center;
      }
      ul {
        display: flex;
        height: 50px;
        line-height: 62px;
  
        li {
          border-bottom: 3px solid transparent;
          padding: 0 5px;
          margin-right: 40px;
          //font-weight: 600;
          font-size: 16px;
          cursor: pointer;
          white-space: nowrap;
  
          i {
            display: inline-block;
            width: 20px;
            height: 20px;
            background-repeat: no-repeat;
            background-position: center;
            vertical-align: text-bottom;
            margin-right: 10px;
          }
          &:hover {
            background-color: #ecf0fe;
          }
          &.act {
            color: #3c65f5;
            border-bottom-color: #3c65f5;
            margin-bottom: -2px;
          }
        }
      }
    }
    main {
      position: absolute;
      // width: calc(100% - 40px);
      width: calc(100% - 0px);
      // background-color: #fff;
      padding: 70px 20px 20px;
    }
    .clear-float {
      clear: both;
    }
  }

  </style>
  